<div >
  <h4 class="card-title">{{Title}}</h4>
  <div class="p-3" *ngIf="Editabile" >
    <div class="row">
      <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
        <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="add()" type="button">{{'inline.add' | translate}}</button>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
      <thead>
      <tr>
        <th>Voce</th>
        <th scope="col">Prezzo</th>
        <th scope="col">Default</th>
        <th scope="col" *ngIf="Editabile" >Azioni</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of Aggiunte">
        <td >
            <span *ngIf="!item.modifica" >
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-info-circle"></i>
              </span>
              {{ item.nome }}
            </span>
            <span *ngIf="item.modifica">
              <input [(ngModel)]="item.nome" placeholder="voce" type="text" name="voce" class="form-control">
            </span>
        </td>
        <td class="align-middle" >
            <span *ngIf="!item.modifica">
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-euro-sign"></i>
              </span>
              {{ item.prezzo | number: '2.2-2'}}
            </span>
          <span *ngIf="item.modifica">
              <input [(ngModel)]="item.prezzo" placeholder="Prezzo" type="number" name="prezzo" class="form-control">
            </span>
        </td>
        <td class="align-middle" >
            <span *ngIf="!item.modifica">
              {{ item.selected ? "Default" : "Optional"}}
            </span>
            <span *ngIf="item.modifica">
              <input [(ngModel)]="item.selected" type="checkbox" name="default" class="form-control">
            </span>
        </td>
        <td class="align-middle" *ngIf="Editabile" >
          <a
             href="javascript:void(0)"
             [ngbTooltip] ="item.modifica ? ('inline.save'|translate) : ('inline.edit'|translate)"
             class="link font-16 text-info font-medium mr-2"
             (click)='edit(item)'>
            <i class="fas" [ngClass]="{'fa-pencil-alt': !item.modifica, 'fa-check': item.modifica}"></i>
          </a>
          <a
             href="javascript:void(0)"
             [ngbTooltip] ="item.modifica ? ('inline.cancel'|translate) : ('inline.delete'|translate)"
             class="link font-16 text-danger font-medium mr-2"
             (click)='delete(item)'>
            <i class="fas" [ngClass]="{'fa-trash-alt': !item.modifica, 'fa-times': item.modifica}"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
<!--  <div class="d-flex justify-content-end">-->
<!--    <span class="text-dark font-16 ">Totale: {{getTotale(myProp.voci) | number: '2.2-2'}} €</span>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-end">-->
<!--    <span class="text-dark font-16">Iva: {{getIva(myProp.voci) | number: '2.2-2'}} €</span>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-end">-->
<!--    <span class="text-dark font-16">Totale Ivato: {{getTotaleIvato(myProp.voci) | number: '2.2-2'}} €</span>-->
<!--  </div>-->
</div>

